<ng-container *ngIf="readonly; else editMode">
  <ng-container
    *ngIf="enableAddressForNativeLanguage; else disableAddressForNativeLanguage"
  >
    <div class="address-readonly">
      {{ getDisplayAddressWithLabel() | replaceNullWith : '-' }}
    </div>
    <div class="p-grid">
      <div class="p-col-12 p-field">
        <div class="p-field-label">
          <label>{{ label | translate }}(Native Language)</label>
        </div>
        <div class="address-readonly">
          {{ getDisplayNativeAddress() | replaceNullWith : '-' }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #disableAddressForNativeLanguage>
    <div class="address-readonly">
      {{ getDisplayAddress() | replaceNullWith : '-' }}
    </div>
  </ng-template>
</ng-container>
<ng-template #editMode>
  <div class="p-grid">
    <div [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown
        #level1DDL
        sigvDropdownSetting
        [(ngModel)]="pageData.useModel.level1"
        [options]="level1Options"
        [styleClass]="
          checkIsLevelInvalid('addressLevel1Requied')
            ? 'invalid-border-color'
            : ''
        "
        placeholder=" {{ 'Address01' | translate }}"
        appendTo="body"
        [showClear]="true"
        class="addr-level-01"
        (ngModelChange)="onLevel1Change()"
      ></p-dropdown>
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressLevel1Requied']"
          class="p-error"
        >
          {{ 'Address01' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
    <div
      *ngIf="checkIsLevelAvalaible(2)"
      [ngClass]="[getColSizeClass(1), 'p-field']"
    >
      <p-dropdown
        #level2DDL
        sigvDropdownSetting
        [(ngModel)]="pageData.useModel.level2"
        [options]="level2Options"
        [disabled]="!level1DDL.value"
        [styleClass]="
          checkIsLevelInvalid('addressLevel2Requied')
            ? 'invalid-border-color'
            : ''
        "
        placeholder=" {{ 'Address02' | translate }}"
        appendTo="body"
        [showClear]="true"
        class="addr-level-02"
        (ngModelChange)="onLevel2Change()"
      ></p-dropdown>
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressLevel2Requied']"
          class="p-error"
        >
          {{ 'Address02' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
    <div
      *ngIf="checkIsLevelAvalaible(3)"
      [ngClass]="[getColSizeClass(1), 'p-field']"
    >
      <p-dropdown
        #level3DDL
        sigvDropdownSetting
        [(ngModel)]="pageData.useModel.level3"
        [options]="level3Options"
        [disabled]="!level2DDL?.value"
        [styleClass]="
          checkIsLevelInvalid('addressLevel3Requied')
            ? 'invalid-border-color'
            : ''
        "
        placeholder=" {{ 'Address03' | translate }}"
        appendTo="body"
        [showClear]="true"
        class="addr-level-03"
        (ngModelChange)="onLevel3Change()"
      ></p-dropdown>
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressLevel3Requied']"
          class="p-error"
        >
          {{ 'Address03' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
    <div
      *ngIf="checkIsLevelAvalaible(4)"
      [ngClass]="[getColSizeClass(1), 'p-field']"
    >
      <p-dropdown
        #level4DDL
        sigvDropdownSetting
        [(ngModel)]="pageData.useModel.level4"
        [options]="level4Options"
        [disabled]="!level3DDL?.value"
        [styleClass]="
          checkIsLevelInvalid('addressLevel4Requied')
            ? 'invalid-border-color'
            : ''
        "
        placeholder=" {{ 'Address04' | translate }}"
        appendTo="body"
        [showClear]="true"
        class="addr-level-04"
        (ngModelChange)="onLevel4Change()"
      ></p-dropdown>
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressLevel4Requied']"
          class="p-error"
        >
          {{ 'Address04' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
  </div>
  <div class="p-grid">
    <div *ngIf="enablePostcode" [ngClass]="[getColSizeClass(1), 'p-field']">
      <p-dropdown
        #postcodeDDL
        sigvDropdownSetting
        [(ngModel)]="pageData.useModel.postcode"
        [options]="postcodeOptions"
        [disabled]="disablePostcodeDDLFunc()"
        [styleClass]="
          checkIsLevelInvalid('addressPostcodeRequied')
            ? 'invalid-border-color'
            : ''
        "
        placeholder=" {{ 'Postcode' | translate }}"
        appendTo="body"
        [showClear]="true"
        class="addr-postcode"
        (ngModelChange)="onPostcodeChange()"
      ></p-dropdown>
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressPostcodeRequied']"
          class="p-error"
        >
          {{ 'Postcode' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
    <div
      [ngClass]="[
        getColSizeClass(enablePostcode ? 3 : 4),
        'p-field',
        'p-fluid'
      ]"
    >
      <input
        #level5Input
        pInputText
        [(ngModel)]="pageData.useModel.level5"
        placeholder=" {{ 'Address05' | translate }}"
        [style.border-color]="
          checkIsLevelInvalid('addressLevel5Requied') ||
          checkIsLevelInvalid('addressLevel5ExceededMaxLength')
            ? '#d7371e'
            : ''
        "
        class="addr-level-05"
        (ngModelChange)="onLevel5Change()"
      />
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressLevel5Requied']"
          class="p-error"
        >
          {{ 'Address05' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
      <small
        *ngIf="
          (control?.dirty || control?.touched) &&
          control?.hasError('addressLevel5ExceededMaxLength')
        "
        class="p-error"
      >
        {{ 'Address05' | translate }}
        {{
          validationMsgMap.addressLevel5ExceededMaxLength
            | translate : { field: '' }
        }}
      </small>
    </div>
  </div>
  <div *ngIf="enableAddressForNativeLanguage" class="p-grid">
    <div class="p-col-12">
      <div class="p-field-label">
        <label>{{ label | translate }}(Native Language)</label>
      </div>
    </div>
    <div [ngClass]="[getColSizeClass(2), 'p-field p-fluid']">
      <input
        #nativeInput
        pInputText
        [(ngModel)]="pageData.useModel.native"
        placeholder=" {{ 'AddressForNative' | translate }}"
        [class.invalid]="checkIsLevelInvalid('addressNativeRequied')"
        class="addr-native"
        (ngModelChange)="onNativeAddrChange()"
      />
      <ng-container
        *ngIf="control?.invalid && (control?.dirty || control?.touched)"
      >
        <small
          *ngIf="control?.errors?.['addressNativeRequied']"
          class="p-error"
        >
          {{ 'AddressForNative' | translate }}
          {{ validationMsgMap.required | translate : { field: '' } }}
        </small>
      </ng-container>
    </div>
    <div
      [ngClass]="[getColSizeClass(2), 'p-field p-fluid']"
      style="line-height: 31px"
    >
      {{ getDisplayNativeAddressOptions() | replaceNullWith : '-' }}
    </div>
  </div>
</ng-template>
